// extracted by mini-css-extract-plugin
export default {"header":"Certificados_header__8wdlt"};